<template>
  <div>
    <div class="position-relative pb-5 pt-5 mt-5" v-if="tests">
      <div class="bg-white shadow-sm p-4 p-md-5 mt-4">
        <LoaderContent
          v-if="isLoading"
          :welcomeMessage="false"
          :alignSpinnerTop="true"
        />

        <!-- Já está inscrito, mas ainda não finalizou todos os testes -->
        <div class="text-center mb-5" v-if="isEnrolled && !allDone">
          <alert-circle-icon style="font-size: 80px" class="text-red-ml" />
          <h3>Finalize os testes para continuar com o processo</h3>
        </div>

        <!-- Já está inscrito e finalizou todos os testes -->
        <div class="text-center mb-5" v-if="isEnrolled && allDone">
          <h3>Obrigado! Todos os testes foram finalizados.</h3>
        </div>

        <div class="d-flex align-items-center p-3 bg-light-2 shadow-sm mb-4" v-for="(test, i) in tests" :key="i">
          <file-document-outline-icon
            class="mr-2"
            style="font-size: 30px"
            v-if="test.status == 'pending'"
          />

          <file-check-outline-icon
            class="mr-2 text-green-ml"
            style="font-size: 30px"
            v-if="test.status == 'finished'"
          />

          <div class="mr-2">
            <h6>{{ test.name }}</h6>
            <span v-if="test.status == 'pending'">Pendente</span>
            <span v-if="test.status == 'finished'">Finalizado</span>
          </div>

          <button v-if="test.source == 'assessfirst' && test.status == 'pending'"  @click="alertAssessfirst(test.url)" class="btn btn-blue-ml ml-auto d-flex align-items-center">
            Começar <chevron-right-icon class="h3 ml-5 mb-0" />
          </button>

          <router-link v-if="test.source != 'assessfirst' && test.status == 'pending'" :to="redirect(`${test.name}/${test.test_id}`)" class="btn btn-blue-ml ml-auto d-flex align-items-center">
            Começar <chevron-right-icon class="h3 ml-5 mb-0" />
        </router-link>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import LoaderContent from "@/components/loader/LoaderContent.vue";
  import EllipsisLoader from "@/components/loader/EllipsisLoader.vue";
  import AlertCircleIcon from "vue-material-design-icons/AlertCircle.vue";
  import FileAlertIcon from "vue-material-design-icons/FileAlert.vue";
  import FileCheckIcon from "vue-material-design-icons/FileCheck.vue";
  import FileDocumentOutlineIcon from "vue-material-design-icons/FileDocumentOutline.vue";
  import FileCheckOutlineIcon from "@/components/mlIcons/FileCheckOutline";
  import ChevronRightIcon from "vue-material-design-icons/ChevronRight.vue";

  export default {
    name: "PendingTests",

    data() {
      return {
        isLoading: false,
        tests: [],
        opportunity: null,
        isEnrolled: false,
      };
    },

    computed: {
      opportunityId() {
        const id = this.$route.params.id.match(/\d+/)[0];
        return id;
      },

      allDone() {
        return this.tests.filter((test) => test.status == "pending").length == 0;
      },
    },

    components: {
      LoaderContent,
      EllipsisLoader,
      AlertCircleIcon,
      FileAlertIcon,
      FileCheckIcon,
      FileDocumentOutlineIcon,
      FileCheckOutlineIcon,
      ChevronRightIcon,
    },

    async mounted(){
      this.isLoading = true;
      await this.getOpportunity();
      await this.getTests();
      await this.checkEnrolled();
    },

    methods: {
      async getTests(){
        this.isLoading = true;

        this.$store
        .dispatch("tests/subscriptionTests", {
          opportunityId: this.opportunityId,
        })
        .then((tests) => {
          this.tests = tests.subscriptionTests.json || [];
          this.isLoading = false;
        })
        .catch((error) => {});
      },

      async getOpportunity() {
        const opportunity = await this.$store.dispatch(
          "opportunities/getOpportunity",
          this.opportunityId,
        );

        if (opportunity) {
          this.opportunity = opportunity;
        }

        return opportunity;
      },

      async checkEnrolled(){
        this.$store
        .dispatch("opportunities/isEnrolled", {
          opportunityId: this.opportunityId,
        })
        .then((response) => {
          this.isEnrolled = response.length > 0;

          if(this.isEnrolled == false){
            this.$swal({title: 'Uoops', html: 'Você não está inscrito na oportunidade', type: 'error'})
            this.$router.push(`/vagas/${this.opportunityId}`);
          }
        });
      },

      alertAssessfirst(link) {
        this.$swal({
          title: "Atenção",
          text: "Você será direcionado para o site Assessfirst para realizar o teste.",
          type: "info",
          showCancelButton: true,
          cancelButtonText: "Fechar",
          confirmButtonText: "Vamos lá!",
          reverseButtons: true,
        }).then((result) => {
          if (result.value) {
            window.open(link, '_blank');
          }
        });
      },

      redirect(testId) {
        window.afterTestBackTo = `/vagas/${this.opportunityId}/inscricao/testes-pendentes`
        return `${testId}`;
      },
    },

  }
</script>

<style lang="scss" scoped>
</style>
